import { useEffect, useState } from 'preact/hooks';
import { createPortal } from 'preact/compat';

export default function Portal({ into, children }) {
	const [hasMounted, setHasMounted] = useState(false);

	useEffect(() => {
		setHasMounted(true);
	}, []);

	if (!hasMounted) {
		return null;
	}

	return createPortal(children, into);
}
